import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import EventEmitter from "../../../services/event-emitter";
import DebtButton from "../../../components/finance/decisions/debt-button";
import EquityButton from "../../../components/finance/decisions/equity-button";

class RaiseCapitalSelectModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  close = () => {
    this.setState({
      show: false
    });
  };

  show = () => {
    this.setState({
      show: true
    });
  };

  componentDidMount() {
    this.eventemitter.on("show-raise-capital-select-modal", this.show);
    this.eventemitter.on("hide-raise-capital-select-modal", this.close);
  }

  componentWillUnmount() {
    this.eventemitter.off("show-raise-capital-select-modal", this.show);
    this.eventemitter.off("hide-raise-capital-select-modal", this.close);
  }

  render() {
    const { show } = this.state;
    const { onDebt, onEquity } = this.props;

    return (
      <Modal id="raiseCapitalSelectModal" show={show} onHide={this.close}>
        <Modal.Header closeButton={true}>
          <h4 className="fn-decisions-modal-title">
            Please click on the type of capital
            <br />
            you want to raise or modify?
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <DebtButton onClick={onDebt} />
            <EquityButton onClick={onEquity} />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default RaiseCapitalSelectModal;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/raise-capital-select-modal.js